import React, { useEffect, useState, useCallback,useMemo } from 'react'
import seqStore from '../../store/seqStore'
import fullScale from '../../assets/fullScale'
import fullMidiScale from '../../assets/fullMidiScale'

export default function Keyboard({ isRecording, MIDIOutput, MIDIInput, gateLength }) {

    const currentTrack = seqStore((state) => state.settings.currentTrack)
    const melody = seqStore((state) => state.melody)
    const setNote = seqStore((state) => state.setNote)
    const length = seqStore((state) => state.settings.length)
    const midiCh = seqStore((state) => state.settings.midiCh)
    const playhead = seqStore((state) => state.settings.playhead)
    const setPlayhead = seqStore((state) => state.setPlayhead)

    const [isPressed, setIsPressed] = useState(null)

    const MIDICH = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f']

    // key click
    const handleKeyRelease = useCallback((keyNote) => {

        const messageOFF = '0x8' + MIDICH[midiCh[currentTrack]]
        const delay = performance.now() + gateLength[currentTrack]

        //select the pressed key
        const pressedKey = document.querySelector(`.key[data-value='${keyNote}']`)
        
        // send the message off
        MIDIOutput.send([messageOFF, keyNote, 0x0], delay)
        
        // Remove the 'keyPressed' class after
        pressedKey.classList.remove('keyPressed')

    })
    const handleKeyPress = useCallback((keyNote) => {
        if (MIDIOutput) {
            const nextPlayhead = (playhead[currentTrack] + 1) % length[currentTrack]
            const messageON = '0x9' + MIDICH[midiCh[currentTrack]]

            // send the note on
            MIDIOutput.send([messageON, keyNote, 0x7f])

            // Update the class of the pressed key dynamically
            const pressedKey = document.querySelector(`.key[data-value='${keyNote}']`)
            pressedKey.classList.add('keyPressed')

            // if recording then store the note value and move the playhead
            if (isRecording) {
                setNote(currentTrack, playhead[currentTrack], keyNote)
                setPlayhead(currentTrack, nextPlayhead)
            }
        }
    }, [MIDIOutput, currentTrack, midiCh, gateLength, playhead, length, isRecording, setNote, setPlayhead, isPressed])

    // build keys
    const keys = useMemo(() => {

        return fullScale.map((item, index) => {
            const keyClass = item.includes('#') ? 'keySharp' : 'keyFlat'
            const pressedClass = index === isPressed ? 'keyPressed' : '' 
            
            return (
                <div
                    key={`key${item}`}
                    className={`key ${keyClass} ${pressedClass}`}
                    onMouseDown={() => handleKeyPress(index)}
                    onMouseUp={() => handleKeyRelease(index)}
                    data-value={index}
                >
                    <p className='keyText'>{item}</p>
                </div>
            )
        })
    }, [isPressed, handleKeyPress])

    // handle MIDI in message
    const getMIDIMessage = useCallback((event) => {
            try {
                const statusByte = event.data[0]
                const messageType = statusByte & 0xf0 // Mask the status byte to get the message type

                if (messageType === 144) { // Note On message
                    const midiNote = event.data[1]
                    const midiVelocity = event.data[2]

                    // Update the class of the pressed key dynamically
                    const pressedKey = document.querySelector(`.key[data-value='${midiNote}']`)
                    pressedKey.classList.add('keyPressed')

                    MIDIOutput.send(['0x9' + midiCh[currentTrack], midiNote, midiVelocity])

                } else if (messageType === 128) { // Note Off message
                    const nextPlayhead = (playhead[currentTrack] + 1) % length[currentTrack]
                    const midiNote = event.data[1]
                    const midiVelocity = event.data[2]

                    // Send note OFF
                    MIDIOutput.send(['0x8' + midiCh[currentTrack], midiNote, midiVelocity])

                    // Remove the 'keyPressed' class after
                    const pressedKey = document.querySelector(`.key[data-value='${midiNote}']`)
                    pressedKey.classList.remove('keyPressed')

                    if (isRecording) {
                        setNote(currentTrack, playhead[currentTrack], midiNote)
                        setPlayhead(currentTrack, nextPlayhead)
                    }

                    /*// Reset isPressed if the released key matches the MIDI note received
                    if (isPressed === midiNote) {
                        setIsPressed(null)
                    }*/
                }
            } catch (error) {
                console.error('Error processing MIDI message:', error)
            }
        },[MIDIOutput, currentTrack, midiCh, playhead, length, isRecording, setNote, setPlayhead])

    // handle MIDI in
    useEffect(() => {
        if (MIDIInput !== "no-device") {
            if (MIDIInput) {
                MIDIInput.onmidimessage = getMIDIMessage
            } else {
                console.error('MIDI Input device not available.')
            }
        } else {
            return
        }
    }, [MIDIInput, getMIDIMessage])
    
    return (
        <div id='sectionWrapper'> {/* row display + keyboard */}
            <div id='keyboardOverflow'>
                <div id='keyboardWrapper'>
                    {keys}
                </div>
            </div>
        </div>
    )
}
